export const calcFilledPercent = ({
  breakDurationSelected = 0,
  breakDurationRequested = 0
}) => {
  if (!breakDurationRequested) return 100
  return Math.min(Math.floor((breakDurationSelected / breakDurationRequested) * 100), 100)
}
